var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavicon03(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1047 5.55244C14.3823 5.69114 14.6884 5.76335 14.9987 5.76335C15.309 5.76335 15.615 5.69114 15.8926 5.55244L19.5512 3.72261C19.7038 3.64637 19.8733 3.61042 20.0437 3.61818C20.2141 3.62594 20.3796 3.67715 20.5246 3.76693C20.6696 3.85672 20.7892 3.9821 20.8721 4.13115C20.955 4.2802 20.9984 4.44798 20.9981 4.61852V17.3814C20.998 17.567 20.9462 17.749 20.8486 17.9068C20.7509 18.0647 20.6112 18.1923 20.4452 18.2753L15.8926 20.5521C15.615 20.6908 15.309 20.763 14.9987 20.763C14.6884 20.763 14.3823 20.6908 14.1047 20.5521L9.89313 18.4463C9.61555 18.3076 9.30951 18.2353 8.99921 18.2353C8.68891 18.2353 8.38286 18.3076 8.10529 18.4463L4.44663 20.2761C4.29399 20.3524 4.12438 20.3883 3.95393 20.3805C3.78348 20.3727 3.61786 20.3214 3.47283 20.2315C3.32781 20.1416 3.2082 20.0161 3.12539 19.8669C3.04259 19.7177 2.99934 19.5498 2.99976 19.3792V6.61734C2.99986 6.4317 3.05164 6.24974 3.1493 6.09186C3.24696 5.93398 3.38664 5.80641 3.55271 5.72342L8.10529 3.44663C8.38286 3.30793 8.68891 3.23572 8.99921 3.23572C9.30951 3.23572 9.61555 3.30793 9.89313 3.44663L14.1047 5.55244Z",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 5.76343V20.7621",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99915 3.23572V18.2343",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon03);
export default __webpack_public_path__ + "static/media/navicon03.013616e5f14718b2e4b4969969b901e7.svg";
export { ForwardRef as ReactComponent };